export default "__VITE_ASSET__ssm7frZG__"